"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5035],{

/***/ 15035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18132);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const VehicleOptionals = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 4497).then(__webpack_require__.bind(__webpack_require__, 74497)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(74497)]
  }
});

const VehicleOptionalsContainer = _ref => {
  let {
    optionals
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(VehicleOptionals, {
    title: t('vehicleOptionalsContainer:title'),
    subTitle: t('vehicleOptionalsContainer:subTitle'),
    includedLabel: t('vehicleOptionalsContainer:included'),
    optionals: optionals
  });
};

/* harmony default export */ __webpack_exports__["default"] = (VehicleOptionalsContainer);

/***/ })

}]);